module.exports = __webpack_public_path__ + "img/trash_icon.c74b23d7.svg";